import { styled } from '@linaria/react';
import { fonts, semantic } from '../../theme/tokens';

export const Heading = styled.h2`
  font-family: ${fonts.body};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const Accent = styled.span`
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.secondary};
`;
